// extracted by mini-css-extract-plugin
export default {"root":"sQbIOsQ","content":"s5rmcIp","title":"nNUwD5K","controls":"K6hCobr"};